import Api from '../api';
import { Url } from '../../constants/environment';

class CommunityService extends Api {
  /**
   * @description 최신
   * @returns
   */
  async recent(page = 1) {
    const res = await this.commonAjax('get', Url.named, `community/board/recent`, {
      page,
    });

    return res;
  }

  /**
   * @description 리스트
   * @returns
   */
  async list_trusted_sites() {
    const res = await this.commonAjax('get', Url.namedChallenger, `community/trusted-sites`);

    return res;
  }

  /**
   * @description 리스트
   * @returns
   */
  async list(board_type = 'free', page = 1, search_type = '', search_content = '', filter = '', game_id = '') {
    let params = { board_type, page };

    if (search_type.length > 0) {
      params['search_type'] = search_type;
    }

    if (search_content.length > 0) {
      params['search_content'] = search_content;
    }

    if (filter.length > 0) {
      params['filter'] = filter;
    }

    if (game_id.length > 0) {
      params['game_id'] = game_id;
    }

    const res = await this.commonAjax('get', Url.namedChallenger, `community/board`, params);

    return res;
  }

  /**
   * @description 베스트
   * @returns
   */
  async best(page = 1) {
    const res = await this.commonAjax('get', Url.namedChallenger, `community/best`, {
      page,
    });

    return res;
  }

  /**
   * @description 상세
   * @returns
   */
  async detailTrustedSite(wr_id) {
    if (!wr_id) {
      return;
    }

    const res = await this.commonAjax('get', Url.named, `community/trusted-sites/${wr_id}`);

    return res;
  }

  async getCustomerCenterNotice(page = 1, category = '') {
    const res = await this.commonAjax('get', Url.named, `community/customercenter/notice`, {
      page,
      category
    });

    return res;
  }

  /**
   * @description 상세
   * @returns
   */
  async detail(wr_id, board_type, from_best = '0') {
    if (!wr_id || !board_type) {
      return;
    }

    const res = await this.commonAjax('get', Url.named, `community/board/${wr_id}`, {
      board_type,
      from_best
    });

    return res;
  }

  /**
   * @description 추천
   * @returns
   */
  async recommend(wr_id, board_type) {
    if (!wr_id || !board_type) {
      return;
    }

    const form = new URLSearchParams();
    form.append('board_type', board_type);

    const res = await this.commonAjax('put', Url.named, `community/board/${wr_id}/good`, form);

    return res;
  }

  /**
   * @description 댓글 입력
   * @returns
   */
  async commentAdd(wr_id, board_type, content, commentType, currentPage = 1) {
    if (!wr_id || !board_type || !content || !commentType) {
      return;
    }

    const form = new FormData();
    form.append('board_type', board_type);
    form.append('content', content);
    form.append('comment_type', commentType);

    const res = await this.commonAjax('post', Url.named, `community/board/${wr_id}/comment`, form);
    if (res.code === 200) {
      alert('등록되었습니다.');
    }

    return res;
  }

  /**
   * @description 대댓글 입력
   * @returns
   */
  async reCommentAdd(wr_id, board_type, content, commentType, commentId) {
    if (!wr_id || !board_type || !content || !commentType) {
      return;
    }

    const form = new FormData();
    form.append('board_type', board_type);
    form.append('content', content);
    form.append('comment_type', commentType);
    form.append('comment_id', commentId);

    const res = await this.commonAjax('post', Url.named, `community/board/${wr_id}/comment`, form);

    if (res.code === 200) {
      alert('등록되었습니다.');
    }

    return res;
  }

  /**
   * @description 댓글 입력
   * @returns
   */
  async commentModify(wr_id, board_type, content, commentId) {
    if (!wr_id || !board_type || !content) {
      return;
    }

    const form = new URLSearchParams();
    form.append('board_type', board_type);
    form.append('content', content);

    const res = await this.commonAjax('put', Url.named, `community/board/${wr_id}/comment/${commentId}`, form);

    return res;
  }

  /**
   * @description 댓글 삭제
   * @returns
   */
  async commentDelete(wr_id, board_type, commentId) {
    if (!wr_id || !board_type || !commentId) {
      return;
    }

    const res = await this.commonAjax('delete', Url.named, `community/board/${wr_id}/comment/${commentId}`, {
      board_type,
    });

    return res;
  }
  /**
   * @description 글등록
   * @returns
   */
  async save(
    boardType,
    subject,
    content,
    isNotice = 'N',
    commentAllowed = 'Y',
    caName = '',
    gameId = '',
    sportsId = ''
  ) {
    if (!boardType || !subject || !content) {
      return;
    }

    const form = new FormData();
    form.append('board_type', boardType);
    form.append('subject', subject);
    form.append('content', content);
    form.append('is_notice', isNotice);
    form.append('comment_allowed', commentAllowed);
    form.append('ca_name', caName);
    if (!!gameId) {
      form.append('game_id', gameId);
      form.append('sports_id', sportsId);
    }

    const res = await this.commonAjax('post', Url.named, `community/board`, form);

    return res;
  }

  /**
   * @description 글수정
   * @returns
   */
  async modify(
    id,
    boardType,
    subject,
    content,
    isNotice = 'N',
    commentAllowed = 'Y',
    caName = '',
    gameId = '',
    sportsId = ''
  ) {
    if (!id || !boardType || !subject || !content) {
      return;
    }

    const form = new URLSearchParams();
    form.append('board_type', boardType);
    form.append('subject', subject);
    form.append('content', content);
    form.append('is_notice', isNotice);
    form.append('comment_allowed', commentAllowed);
    form.append('ca_name', caName);
    if (!!gameId) {
      form.append('game_id', gameId);
      form.append('sports_id', sportsId);
    }

    const res = await this.commonAjax('put', Url.named, `community/board/${id}`, form);

    return res;
  }

  /**
   * @description 글삭제
   * @returns
   */
  async delete(id, boardType) {
    if (!id || !boardType) {
      return;
    }

    const res = await this.commonAjax('delete', Url.named, `community/board/${id}`, {
      board_type: boardType,
    });

    return res;
  }

  /**
   * @description 신고하기
   * @returns
   */
  async report({ category, relId, relTable, targetId, content, type }) {
    const form = new FormData();
    form.append('category', category);
    form.append('rel_id', relId);
    form.append('rel_table', relTable);
    form.append('target_id', targetId);
    if (!!type) {
      form.append('type', type);
    }
    if (!!content) {
      form.append('content', content);
    }

    const res = await this.commonAjax('post', Url.named, `community/report`, form)

    return res
  }

  /**
   * @description 파일 업로드 (이미지/비디오) with reCAPTCHA
   * @param {File} file - 업로드할 파일
   * @param {string} recaptchaToken - reCAPTCHA 토큰
   * @returns {Promise<{url: string, name: string}>}
   */
  async uploadFile(file, recaptchaToken) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('g-recaptcha-response', recaptchaToken)

    const res = await this.commonAjax('post', Url.namedChallenger, 'community/board/upload-file', formData)

    return res
  }

  /**
   * @description 다중 파일 업로드 (이미지/비디오) with reCAPTCHA
   * @param {File[]} files - 업로드할 파일 배열
   * @param {string} recaptchaToken - reCAPTCHA 토큰
   * @returns {Promise<{files: Array<{url: string, name: string}>}>}
   */
  async uploadFiles(files, recaptchaToken) {
    const formData = new FormData()
    files.forEach(file => {
      formData.append('files[]', file)
    })
    formData.append('g-recaptcha-response', recaptchaToken)

    const res = await this.commonAjax('post', Url.namedChallenger, 'community/board/upload-file', formData)

    return res
  }

  /**
   * @description 파일 업로드 with progress tracking (XHR 사용)
   * @param {File|Blob} file - 업로드할 파일
   * @param {string} filename - 파일명
   * @param {string} recaptchaToken - reCAPTCHA 토큰
   * @param {Function} onProgress - Progress callback (0-100)
   * @returns {Promise<string>} - 업로드된 파일 URL
   */
  uploadFileWithProgress(file, filename, recaptchaToken, onProgress) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('files[]', file, filename)
      formData.append('g-recaptcha-response', recaptchaToken)

      const xhr = new XMLHttpRequest()
      xhr.open('POST', Url.namedChallenger + 'community/board/upload-file', true)

      // Get session ID from cookie
      const sessionId = require('../../utils/cookie').default.getCookie('PHPSESSID')
      if (sessionId) {
        xhr.setRequestHeader('NAMED-SESSION', sessionId)
      }

      xhr.upload.addEventListener('progress', (e) => {
        if (e.lengthComputable && onProgress) {
          onProgress((e.loaded / e.total) * 100)
        }
      })

      xhr.onload = function () {
        if (xhr.status === 200) {
          try {
            const response = JSON.parse(xhr.responseText)
            if (response && response.files && response.files.length > 0) {
              resolve(response.files[0].url)
            } else {
              reject(response.message || '업로드에 실패했습니다.')
            }
          } catch (e) {
            reject('응답 파싱 중 오류가 발생했습니다.')
          }
        } else {
          reject('업로드 중 오류가 발생했습니다.')
        }
      }

      xhr.onerror = function () {
        reject('업로드 중 오류가 발생했습니다.')
      }

      xhr.send(formData)
    })
  }
}

export default new CommunityService()
